/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramChatsUserControllerFindAllQueryResponse,
  TelegramChatsUserControllerFindAllQueryParams,
  TelegramChatsUserControllerFindAll401,
} from '../../types/TelegramChatsUserControllerFindAll.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramChatsUserFindAll } from '../../methods/telegramChatsUserFindAll.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramChatsUserFindAllQueryKey = (params?: TelegramChatsUserControllerFindAllQueryParams) =>
  [{ url: '/api/user/telegram/chats' }, ...(params ? [params] : [])] as const;

export type TelegramChatsUserFindAllQueryKey = ReturnType<typeof telegramChatsUserFindAllQueryKey>;

export function telegramChatsUserFindAllQueryOptions(
  params?: TelegramChatsUserControllerFindAllQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramChatsUserFindAllQueryKey(params);
  return queryOptions<
    TelegramChatsUserControllerFindAllQueryResponse,
    ResponseErrorConfig<TelegramChatsUserControllerFindAll401>,
    TelegramChatsUserControllerFindAllQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramChatsUserFindAll(params, config);
    },
  });
}

/**
 * {@link /api/user/telegram/chats}
 */
export function useTelegramChatsUserFindAll<
  TData = TelegramChatsUserControllerFindAllQueryResponse,
  TQueryData = TelegramChatsUserControllerFindAllQueryResponse,
  TQueryKey extends QueryKey = TelegramChatsUserFindAllQueryKey,
>(
  params?: TelegramChatsUserControllerFindAllQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramChatsUserControllerFindAllQueryResponse,
        ResponseErrorConfig<TelegramChatsUserControllerFindAll401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramChatsUserFindAllQueryKey(params);

  const query = useQuery(
    {
      ...telegramChatsUserFindAllQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramChatsUserControllerFindAll401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
